<template>
  <div class="resident-manage app-region blank-l-h blank-r-h">
    <a-row :gutter="64" type="flex">
      <a-col :span="24" :xl="6" class="divide">
        <div class="page-title">社区列表</div>
        <a-input placeholder="请输入关键词" v-model="tree.keyword" @change="filterKeyword(tree.data, 'tree.searchData', tree.keyword, tree.params.title, tree.params.children)"></a-input>
        <a-spin tip="加载中..." :spinning="tree.loading">
          <a-tree block-node :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params" @select="selectTreeNode" :selected-keys="tree.selectedKeys" :load-data="loadData"></a-tree>
        </a-spin>
      </a-col>
      <a-col :span="24" :xl="18">
        <div class="page-title">{{name}}（{{total}}）</div>
        <label-list :id="id" @total="setTotal"></label-list>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import LabelService from '@/io/label.js';
  import LabelList from '@/views/community/label/List.vue';

  export default {
    name: 'ResidentManage',
    data() {
      return {
        tree: {
          selectedKeys: [],
          keyword: null,
          loading: false,
          data: [],
          searchData: [],
          params: {
            children: 'children',
            title: 'name',
            key: 'id'
          }
        },
        id: null,
        // communityId: null,
        name: null,
        total: null
      }
    },
    mounted () {
      this.initTreeData().then(() => {
        this.selectTreeNode([this.tree.data[0][this.tree.params.key]]);
      });
    },
    components: {
      LabelList,
    },
    methods: {
      formatTreeNode(data, communityId) {
        this.$depthSearchTree(node => {
          node.isLeaf = true;
          node.communityId = communityId;
        }, data);
      },
      loadData(data) {
        return LabelService.list(data.dataRef.id).then(res => {
          this.formatTreeNode(res, data.dataRef.communityId);
          data.dataRef.children = res;
        }).catch(err => {});
        // if ((!data.dataRef.level || data.dataRef.level < 4) && data.dataRef.children && !data.dataRef.children.length) {
        //   if (data.dataRef.isCommunity) {
        //     return BuildingService.listPage(data.dataRef[this.tree.params.key]).then(res => {
        //       this.formatTreeNode(res, data.dataRef.id);
        //       data.dataRef.children = res;
        //     });
        //   } else {
        //     return BuildingService.floorHouseStatusList(data.dataRef[this.tree.params.key], data.dataRef.communityId).then(res => {
        //       this.formatTreeNode(res, data.dataRef.communityId);
        //       data.dataRef.children = res;
        //     });
        //   }
        // } else {
        //   return new Promise((resolve, reject) => resolve());
        // }
      },
      selectTreeNode(selectedKeys) {
        // if (selectedKeys.length) {
        //   this.tree.selectedKeys = selectedKeys;
        //   this.$depthSearchTree(node => {
        //     if (node[this.tree.params.key] === selectedKeys[0]) {
        //       if (node.isCommunity) {
        //         this.id = null;
        //         this.communityId = node[this.tree.params.key];
        //       } else {
        //         this.id = node[this.tree.params.key];
        //         this.communityId = node.communityId;
        //       }
        //       this.name = node[this.tree.params.title];
        //     }
        //   }, this.tree.data);
        // }
      },
      setTotal(total) {
        this.total = total;
      },
      initTreeData() {
        this.tree.loading = true;
        return CommunityService.listPage().then(res => {
          this.tree.data = res.map(val => {
            val.children = [];
            val.isCommunity = true;
            return val;
          });
        }).catch(err => {}).finally(() => {
          this.tree.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>